
import React from 'react';
import './statusForm.css';
import PropTypes from "prop-types";

const Info = ({ headerTitle, content, className }) => {
    return <div className={className}>
        <div className="info-container">
            <div className="u-mt-xsmall u-mb-small">
                <span>
                    <button id="info-button-tooltip" className="info-button-tooltip js-tooltip c-tooltip tooltip-icon u-mh-xsmall">
                        i
                    </button>
                </span>
            </div>
            <div className="header-container">
                <p className="header">{headerTitle}</p>
                <div className="text-content">{content}</div>
            </div>
        </div>
        <style>
            {`
                .paddingTop {
                    padding-top:1px;
                }
                .info-button-tooltip.tooltip-icon {
                    color: #676767 !important;
                    font-size: 14px !important;
                    cursor: unset !important;
                }
                .info-button-tooltip.tippy-box {
                    display: none !important;
                }
            `}
        </style>
    </div>
}

Info.propTypes = {
    headerTitle: PropTypes.string,
    content: PropTypes.string,
    className: PropTypes.string,
};

export default Info;